import { defineComponent, ref, computed } from "vue";
import { localKey } from "@/dto/local.key.dto";
import { useRoute } from "vue-router";
import { onMounted } from "vue";
import { defaultVersion } from "@/services/utils/helper.util";

export default defineComponent({
  name: "c-navbar",

  props: {
    loading: { type: Boolean, default: false },
    style: { type: String, default: "" },
    class: { type: String, default: "" },
  },

  setup(props) {
    const className = ref<string>(props.class);
    const styleName = ref<string>(props.style);
    const isDropdown = ref<boolean>(false);
    const isLogout = ref<boolean>(false);

    const getPageTitle = (pageTitle: string): string => {
      return pageTitle;
    };

    const getPageBreadcrumb = (
      lang: string,
      breadcrumb: {
        adminRouteUrl: string;
        title: string;
        titleForeign: string;
      }[]
    ): string => {
      const route = useRoute();
      const currentRoute = route.path.split("/").filter(Boolean);
      const newBreadcrumb = breadcrumb.filter(
        (bread) => bread.adminRouteUrl === `/${currentRoute[0]}`
      );

      return lang === "en"
        ? newBreadcrumb[0]?.title
        : newBreadcrumb[0]?.titleForeign;
    };

    const isLoading = computed(() => props.loading);

    const onClose = (): void => {
      isDropdown.value = false;
    };

    const onLogout = (): void => {
      isLogout.value = false;
      localStorage.removeItem(localKey?.accessToken);
      localStorage.removeItem(localKey?.refreshToken);
      location.reload();
    };

    const cancelLogout = (): void => {
      isLogout.value = false;
    };

    // change font
    const changeRootFontFamily = (
      primaryFont: string,
      secondaryFont: string,
      fallbackFont: string
    ): void => {
      const fontFamily = `"${primaryFont}", "${secondaryFont}", ${fallbackFont}`;
      document.documentElement.style.setProperty("--font-family", fontFamily);
      localStorage.setItem("font-family", fontFamily);
    };

    const loadFontFamilyFromLocalStorage = (): void => {
      const storedFontFamily = localStorage.getItem("font-family");
      if (storedFontFamily) {
        document.documentElement.style.setProperty(
          "--font-family",
          storedFontFamily
        );
      }
    };

    onMounted(() => {
      loadFontFamilyFromLocalStorage();
    });

    return {
      className,
      styleName,
      isLoading,
      isDropdown,
      isLogout,
      getPageTitle,
      onClose,
      onLogout,
      cancelLogout,
      getPageBreadcrumb,

      changeRootFontFamily,
      version: defaultVersion(),
    };
  },
});
